export const PRIMARY_CARE_PHYSICIAN_OPTIONS = {
  FULL_NAME: "Patient.PrimaryCarePhysician.FullName",
  FIRST_NAME: "Patient.PrimaryCarePhysician.FirstName",
  LAST_NAME: "Patient.PrimaryCarePhysician.LastName",
  NPI: "Patient.PrimaryCarePhysician.NPI",
  EMAIL: "Patient.PrimaryCarePhysician.Email",
  PHONE: "Patient.PrimaryCarePhysician.Phone",
  FAX_NUMBER: "Patient.PrimaryCarePhysician.FaxPhone",
  PRACTICE_NAME: "Patient.PrimaryCarePhysician.PracticeName",
  ADDRESS: "Patient.PrimaryCarePhysician.Address"
};
